export default "__VITE_ASSET__BmY2qrNR__"